import "core-js/modules/es6.regexp.match.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import { stringify } from 'qs';
import keys from 'lodash/keys';
import * as types from './types';
import fetchSearch from '~/services/search';
export default {
  fetchContent: function fetchContent(_ref, _ref2) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var commit, keyword, query, _yield$fetchSearch, productSearch, details, total, products, redirectUrl, currentQuery;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              keyword = _ref2.keyword, query = _ref2.query;

              if (keyword) {
                _context.next = 6;
                break;
              }

              commit(types.SET_DESCRIPTION, {
                query: ''
              });
              commit(types.SET_PRODUCTS, {
                products: [],
                total: 0
              });
              return _context.abrupt("return");

            case 6:
              _context.next = 8;
              return fetchSearch(_this, keyword, query);

            case 8:
              _yield$fetchSearch = _context.sent;
              productSearch = _yield$fetchSearch.productSearch;

              if (productSearch) {
                _context.next = 14;
                break;
              }

              commit(types.SET_DESCRIPTION, {
                query: keyword
              });
              commit(types.SET_PRODUCTS, {
                products: [],
                total: 0
              });
              return _context.abrupt("return");

            case 14:
              details = productSearch.details, total = productSearch.total, products = productSearch.products;

              if (!details.redirect) {
                _context.next = 20;
                break;
              }

              redirectUrl = "".concat(details.redirect_to);
              currentQuery = keys(query).length ? "&".concat(stringify(query)) : '';

              if (redirectUrl.match(/^\/[A-Z]{2}\/[a-z]{2}\/(?:c|e|p|q|s)\//)) {
                _this.app.context.redirect(301, "".concat(redirectUrl).concat(currentQuery));
              } else {
                window.location.href = "".concat(redirectUrl).concat(currentQuery);
              }

              return _context.abrupt("return");

            case 20:
              // For Algolia search results, total isn't present in details
              if (!details.total && total) {
                details.total = total;
              }

              commit(types.SET_DESCRIPTION, details);
              commit(types.SET_PRODUCTS, {
                products: products,
                total: total
              });

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  appendProducts: function appendProducts(_ref3, _ref4) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var commit, keyword, query, _yield$fetchSearch2, products;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref3.commit;
              keyword = _ref4.keyword, query = _ref4.query;
              _context2.next = 4;
              return fetchSearch(_this2, keyword, query);

            case 4:
              _yield$fetchSearch2 = _context2.sent;
              products = _yield$fetchSearch2.productSearch.products;
              commit(types.APPEND_PRODUCTS, products);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  prependProducts: function prependProducts(_ref5, _ref6) {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var commit, keyword, query, _yield$fetchSearch3, products;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref5.commit;
              keyword = _ref6.keyword, query = _ref6.query;
              _context3.next = 4;
              return fetchSearch(_this3, keyword, query);

            case 4:
              _yield$fetchSearch3 = _context3.sent;
              products = _yield$fetchSearch3.productSearch.products;
              commit(types.PREPEND_PRODUCTS, products);

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
};